import React, { useEffect, useRef, useState } from 'react'
import styles from './OnboardingCaddieDomestic.module.scss'
import { TourSection } from '../../components/TourSection'
import { uploadS3, useAuthStatus, useToken } from '../../utils'
import { updateUserProfileImage } from '../../services/api'
import { Link } from 'react-router-dom'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../store'
import OnboardingNext from './OnboardingNext'

export const OnboardingCaddieDomestic = () => {
	const { actions, state } = useStateMachine({ updateStore })
	const fileInputRef = useRef(null)
	const [noToursForSelectedGender, setNoToursForSelectedGender] = useState(false)
	const [auth, onChangeAuthStatus] = useAuthStatus()
	const token = useToken()

	// Store에서 프로필 이미지와 투어 선택 데이터 가져오기
	const profileImage = state.onboardingInput?.profileImage || '/images/Onboard-default-image.png'
	const toursCheckedByChild = state.onboardingInput?.selectedTourIds || []

	const isNextButtonDisabled = toursCheckedByChild.length === 0 && !noToursForSelectedGender

	const handleImageChangeClick = () => {
		fileInputRef.current.click()
	}

	const handleNoToursAvailable = (isNoTours) => {
		setNoToursForSelectedGender(isNoTours)
	}

	const handleFileChange = async (event) => {
		const file = event.target.files[0]

		if (file) {
			// 1. 파일 확장자 유효성 검사 (JPG, PNG만 허용)
			const allowedTypes = ['image/jpeg', 'image/png']
			if (!allowedTypes.includes(file.type)) {
				alert('JPG 및 PNG 이미지 형식만 허용됩니다.')
				return
			}

			// 2. 파일 크기 유효성 검사 (5MB 이하만 허용)
			const maxSize = 5 * 1024 * 1024
			if (file.size > maxSize) {
				alert('파일 크기는 5MB 이하여야 합니다.')
				return
			}

			const userId = auth.user?.id

			try {
				// S3에 이미지 업로드
				const imageUrl = await uploadS3(userId, 'profile', file)

				if (imageUrl) {
					// Store에 프로필 이미지 저장
					actions.updateStore({
						onboardingInput: {
							...state.onboardingInput,
							profileImage: `${imageUrl}?timestamp=${new Date().getTime()}`,
						},
					})

					// 데이터베이스에 이미지 URL 저장
					await updateUserProfileImage(token, userId, imageUrl)
					console.log(
						'프로필 이미지가 데이터베이스에 성공적으로 저장되었습니다:',
						imageUrl,
					)
				} else {
					console.error('S3 이미지 업로드 실패: imageUrl이 반환되지 않았습니다.')
					throw new Error('Failed to upload image to S3.')
				}
			} catch (error) {
				console.error('이미지 변경 중 오류 발생:', error)
				alert('프로필 이미지 변경 중 오류가 발생했습니다. 다시 시도해주세요.')
			}
		}
	}

	const handleSelectedToursFromChild = (selectedIds) => {
		actions.updateStore({
			onboardingInput: {
				...state.onboardingInput,
				selectedTourIds: selectedIds,
			},
		})
	}

	return (
		<div className="Onboard-default-container">
			<div className="header">
				<div className="header-image-container">
					<div className="profile-image-container">
						<img src={profileImage} alt="프로필 이미지" className="profile-image" />
					</div>
					<div className="change-image-container" onClick={handleImageChangeClick}>
						<img src="/images/pencil-icon.png" className="change-image" />
					</div>
					<input
						type="file"
						ref={fileInputRef}
						style={{ display: 'none' }}
						accept="image/*"
						onChange={handleFileChange}
					/>
				</div>
				<div className="regist-complete-message">
					<div>{auth?.user?.name || '캐디'}님</div>
					<div>가입이 완료되었어요!</div>
				</div>
				<div className="contract-announcement">
					<div>선호 계약정보를 지금 입력해보세요. </div>
					<div>평균 3일 이내 매칭될 확률이 2배 높아져요!</div>
				</div>
				<div className="contract-comment">
					입력한 조건은 프로에게 추천 시 참고되며, 언제든지 수정할 수 있어요.
				</div>
			</div>
			<OnboardingNext noMarginTop={true} mainFormMarginTop24px={true} isSkipDisabled={true} />
		</div>
	)
}
